import React from "react";
import { IconProps } from "./types";

export function UploadIcon({ size = 72, ...props }: IconProps) {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 81 71"
      fill="inherit"
      stroke="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.6531 16.042C41.4936 16.5766 41.7981 17.1383 42.3323 17.2976L42.4248 17.3252L42.4283 17.3212C42.9342 17.4204 43.4394 17.1194 43.588 16.6176C44.9677 11.9818 49.3141 8.74342 54.1567 8.74342C54.7142 8.74342 55.1663 8.29127 55.1663 7.7338C55.1663 7.17632 54.7142 6.72419 54.1567 6.72419C48.2313 6.72419 43.2519 10.6693 41.6531 16.042ZM41.6531 16.042L41.7968 16.0849M41.6531 16.042C41.6531 16.0421 41.653 16.0421 41.653 16.0421L41.7968 16.0849M41.7968 16.0849C41.6611 16.5399 41.9202 17.0182 42.3752 17.1539L41.7968 16.0849Z"
        fill="inherit"
        stroke="inherit"
        strokeWidth="0.3"
      />
      <path
        d="M66.19 49.8547H61.0325C60.5579 49.8547 60.1729 49.4697 60.1729 48.9951C60.1729 48.5205 60.5578 48.1355 61.0325 48.1355H66.19C73.2995 48.1355 79.0841 42.3509 79.0841 35.2414C79.0841 28.132 73.2995 22.3474 66.19 22.3474H66.066C65.8167 22.3474 65.5797 22.2393 65.4164 22.0508C65.2531 21.8623 65.1794 21.6124 65.215 21.3656C65.2918 20.8302 65.3304 20.2923 65.3304 19.7686C65.3304 13.6071 60.317 8.59369 54.1555 8.59369C51.7585 8.59369 49.4725 9.34277 47.5445 10.7605C47.1208 11.0718 46.5191 10.9336 46.2741 10.4676C40.8138 0.0701319 26.5521 -1.32614 19.1581 7.71875C16.0434 11.5292 14.8195 16.4861 15.8002 21.3171C15.9083 21.8507 15.4999 22.3481 14.9578 22.3481H14.6133C7.50385 22.3481 1.71929 28.1326 1.71929 35.2421C1.71929 42.3516 7.50385 48.1361 14.6133 48.1361H19.7709C20.2455 48.1361 20.6305 48.5211 20.6305 48.9957C20.6305 49.4704 20.2455 49.8554 19.7709 49.8554H14.6133C6.55571 49.8554 0 43.2996 0 35.242C0 27.4104 6.19277 20.9978 13.9385 20.6441C13.2109 15.6319 14.6023 10.5762 17.827 6.63075C25.7433 -3.05389 40.9143 -1.96837 47.3274 8.83071C49.3734 7.54805 51.7145 6.87517 54.1552 6.87517C61.6203 6.87517 67.5356 13.2289 67.018 20.6521C74.6924 21.0825 80.803 27.4614 80.803 35.2414C80.803 43.2996 74.2473 49.8547 66.1896 49.8547L66.19 49.8547Z"
        fill="inherit"
      />
      <path
        d="M18.6459 48.5097C18.6459 60.4424 28.3537 70.15 40.2862 70.15C52.2189 70.15 61.9266 60.4422 61.9266 48.5097C61.9266 36.577 52.2189 26.8694 40.2862 26.8694C28.3535 26.8694 18.6459 36.5772 18.6459 48.5097ZM20.6655 48.5097C20.6655 37.6911 29.4675 28.889 40.2862 28.889C51.1048 28.889 59.907 37.691 59.907 48.5097C59.907 59.3283 51.1048 68.1304 40.2862 68.1304C29.4677 68.1304 20.6655 59.3284 20.6655 48.5097Z"
        fill="inherit"
        stroke="inherit"
        strokeWidth="0.3"
      />
      <path
        d="M39.9008 57.1609C39.9008 57.5912 40.2498 57.9402 40.6801 57.9402C41.1104 57.9402 41.4594 57.5917 41.4594 57.1609V40.7982C41.4594 40.3679 41.1104 40.0189 40.6801 40.0189C40.2498 40.0189 39.9008 40.3679 39.9008 40.7982V57.1609Z"
        fill="inherit"
        stroke="inherit"
        strokeWidth="0.3"
      />
      <path
        d="M40.6806 41.9019L36.1972 46.3853L40.6806 41.9019ZM40.6806 41.9019L45.1641 46.3854C45.3161 46.5374 45.5161 46.6137 45.7152 46.6137L40.6806 41.9019ZM35.0949 46.3854C35.3993 46.6898 35.893 46.69 36.1971 46.3854L40.2356 40.3547L40.1295 40.2487L40.1295 40.2487C40.1295 40.2487 40.1294 40.2488 40.1294 40.2488L35.0949 45.2833C34.7905 45.5877 34.7905 46.081 35.0949 46.3854ZM45.7152 46.6137C45.914 46.6137 46.1141 46.5381 46.2663 46.3854L45.7152 46.6137Z"
        fill="inherit"
        stroke="inherit"
        strokeWidth="0.3"
      />
    </svg>
  );
}
